import React, { useEffect, useContext, useState } from "react";
import { Desktop, MEDIUM, Mobile } from "../util/breakpoints";
import NavigationPrimary from "./NavigationPrimary";
import NavLink from "../molecules/NavLink";
import Logo from "../molecules/Logo";
import MenuToggleButton from "../molecules/MenuToggleButton";
import { HeaderThemeContext, headerThemes } from "../../context";
import useSiteData from '../../useSiteData'
import useMediaQuery from '../util/useMediaQuery'
import { convertToInternalUrl } from "../../util/urlTransforms"

export default ({ onMenuToggleButtonClick, isActive, isMenuOpen, topBannerOffset }) => {

    const signInUrl = convertToInternalUrl( useSiteData().pageSettings.signInUrl, true )
    const signInText = useSiteData().pageSettings.signInText

    const isMediumUpQuery = useMediaQuery({ minWidth: MEDIUM });
    const [ isMediumUp, setIsMediumUp ] = useState(false);
    const { theme } = useContext(HeaderThemeContext);
    const [, requestUpdate] = useState();

    const body = typeof document === 'undefined' ? null : document.body

    useEffect(() => {
      setIsMediumUp(isMediumUpQuery);
    }, [isMediumUpQuery]);

    // dynamic positioning based on height of the top banner
    const offsetStyle = topBannerOffset ? {top: topBannerOffset + 'px' } : {}

    if (theme === headerThemes.INVISIBLE) return null;

    return (
        <header
            className={
                "o-header" +
                (theme === headerThemes.DARK ? " o-header--dark" : "") +
                (isMediumUp ? " u-container" : "") +
                (isActive ? " o-header--active": "")                 
            }
            role="banner"
            style={ offsetStyle }
        >
            <div className="o-header__col">
                <Logo
                    onClick={ () => {
                        if (isMenuOpen) {
                            onMenuToggleButtonClick();
                        } else {
                            requestUpdate();
                        }
                    } }
                    isRed={ theme === headerThemes.DARK || isActive }
                />
            </div>
            <div className="o-header__col">
                <Desktop>
                    <div className="o-header__row">
                        <NavLink
                            isDark={ theme === headerThemes.DARK }
                            signInUrl={ signInUrl }
                            signInText={ signInText }
                        />
                    </div>
                    <NavigationPrimary/>
                </Desktop>
                <Mobile>
                    <MenuToggleButton
                        isRed={ theme === headerThemes.DARK }
                        isActive={ isActive }
                        onClick={ onMenuToggleButtonClick }/>
                </Mobile>
            </div>
        </header>
    )
}
